import { DebugElement } from '@angular/core';
import { ComponentFixture } from '@angular/core/testing';

import { setProps } from '../internals/query';
import { BaseSpec } from '../base/base-Spec';
import { HostComponent } from '../Spec-host/host-component';

/**
 * @publicApi
 */
export class SpecPipe<P, H = HostComponent> extends BaseSpec {
  constructor(public hostComponent: H, public fixture: ComponentFixture<any>, public debugElement: DebugElement, public element: Element) {
    super();
  }

  public detectChanges(): void {
    this.fixture.detectChanges();
  }

  public setHostInput<K extends keyof H>(input: Partial<H>): void;
  public setHostInput<K extends keyof H>(input: K, inputValue: H[K]): void;
  public setHostInput(input: any, value?: any): void {
    setProps(this.hostComponent, input, value, false);
    this.detectChanges();
  }
}
